export default {"src":"/_next/static/media/cp-celebration.afed3312.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};